export default __webpack_public_path__ + "static/media/wellness3.e068d82f.jpeg";